module.exports = __webpack_public_path__ + "media/images/img-travel-9-05eb8fbd.jpg";